/// <reference path="RunBookGrid.ts" />
namespace Matrix.Workflow {

    @Serenity.Decorators.element("<div/>")
    @Serenity.Decorators.registerEditor()
    export class RunBookEditor extends Serenity.DataGrid<RunBookItem, RunBookEditorOptions> implements Serenity.IReadOnly {

        protected getIdProperty() { return 'StepCode'; }

        constructor(container: JQuery, opt: RunBookEditorOptions) {
            super(container, opt);
            let dependencies = this.getDependencies(opt.stepId);
            let items = dependencies.map(key => <RunBookItem>{
                StepCode: key
            });
            this.setItems(items);
            this.setRadio();
        }
        protected setHeight() {
            this.slickContainer.addClass('full-height-page');
            this.slickContainer.css('height', '500px');
            this.slickContainer.css('flex', '1 1 auto');
        }

        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.groupingPanel = true
            opt.autoHeight = false;

            return opt;
        }
        protected getColumns() {
            let cols: Slick.Column[] = [
                {
                    name: Q.text('Dependencies'),
                    field: 'StepCode',
                    format: Serenity.SlickFormatting.treeToggle(() => this.view, x => x.StepCode, ctx => {
                        let item = ctx.item;
                        let klass = "edit string";
                        return '<span class="effective-permission ' + klass + '">' + Q.htmlEncode(ctx.value) + '</span>';
                    }),
                    width: 400,
                    sortable: false
                }, {
                    name: Q.text('Select'), field: 'Grant',
                    format: ctx => {
                        let item1 = ctx.item;
                        let klass1 = this.getItemGrantRevokeClass(item1, true);
                        return "<span class='check-box grant no-float " + klass1 + "'></span>";
                    },
                    width: 65,
                    sortable: false,
                    headerCssClass: 'align-center',
                    cssClass: 'align-center'
                }];
            return cols;
        }

        private getItemGrantRevokeClass(item: RunBookItem, grant: boolean): string {
            return ((item.GrantRevoke === grant) ? ' checked' : '');
        }

        private getDependencies(stepId) {
            var keys: string[];
            Workflow.RunBookService.ListDependencies({
                StepId: stepId
            }, (response) => {
                keys = response.Entities;
            }, { async: false })
            return keys;
        }

        protected getInitialTitle() {
            return null;
        }

        get_value(): string {
            let result = "";
            var andor = $("input[name='radio1']:checked").val() == "andison"
            for (let item of this.view.getItems()) {
                if (item.GrantRevoke != null && item.GrantRevoke == true) {
                    if (andor) {
                        result = result + item.StepCode + ",";
                    } else {
                        result = result + item.StepCode + "|";
                    }
                }
            }
            return result;
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this._value && this._value.length > 0;
        }

        private _value: RunBookItem[];

        private _readOnly: boolean;

        public get_readOnly() {
            return this._readOnly;
        }

        public setItems(items: RunBookItem[]): void {
            this.view.setItems(items, true);
        }

        protected onClick(e, row, cell): void {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented()) {
                return;
            }
            let target = $(e.target);
            let grant = target.hasClass('grant');
            if (grant) {
                e.preventDefault();
                let item = this.itemAt(row);
                let checkedOrPartial = target.hasClass('checked');
                if (checkedOrPartial) {
                    grant = null;
                }
                else {
                    grant = grant !== checkedOrPartial;
                }
                item.GrantRevoke = grant;
                this.slickGrid.invalidate();
            }
        }

        protected onViewSubmit() {
            return false;
        }

        set_value(value: RunBookItem[]) {
            let isAnd = true;
            for (let item of this.view.getItems()) {
                item.GrantRevoke = null;
            }
            if (value != null) {
                for (let row of value) {
                    let r = this.view.getItemById(row.StepCode);
                    if (r) {
                        r.GrantRevoke = true;
                    }
                    this.setRadio();
                    if (row.StepCode == 'ANDISTRUE') {
                        isAnd = true;
                    } else {
                        isAnd = false;
                    }
                }
            }
            this.setItems(this.getItems());
            if (isAnd) {
                ($("input[name=radio1][value=andison]")[1] as any).checked = true
            } else {
                ($("input[name=radio1][value=andisoff]")[1] as any).checked = true
            }
        }

        protected setRadio() {
            if ($("input[name=radio1][value=andisoff]").length < 2)
                $(".slick-grouping-panel").html("<div class='s-runbook-dialogRadio'><label class=\"radio-inline\"> <input type=\"radio\" name=\"radio1\" value=\"andison\"  checked>AND</label> <label class=\"radio-inline\"> <input type=\"radio\" value=\"andisoff\" name=\"radio1\">OR </label></div>");
            ($("input[name=radio1][value=andison]")[1] as any).checked = true;
            $(".grid-toolbar").removeClass("s-Toolbar");
            $(".grid-toolbar").removeClass("grid-toolbar");
            $(".s-RunBookPickerDialog").addClass("s-runbook-picker");
            this.slickContainer.css('min-height', '360px');
        }
    }

    export interface RunBookEditorOptions {
        showRevoke?: boolean;
        stepId?: number;
    }
    export interface RunBookItem {
        StepCode?: string;
        GrantRevoke?: boolean;
    }
}
